import { CollegeSlider, TagList } from "../components/home";
import { registerWidget, DME, DMEData, generalSettings } from "dmeditor";
import { useEffect, useRef } from "react";
import {
  TwitterTimelineEmbed,
  TwitterShareButton,
  TwitterFollowButton,
  TwitterHashtagButton,
  TwitterMentionButton,
  TwitterTweetEmbed,
  TwitterMomentShare,
  TwitterDMButton,
  TwitterVideoEmbed,
  TwitterOnAirButton,
} from "react-twitter-embed";
import YouTubeVideoList from "./YoutubeList";

export interface YoutubeEnitity {
  channelID: string;
  height?: number;
  apiKey?: string;
}

export const Youtube = (props: DME.WidgetRenderProps<YoutubeEnitity>) => {
  const {
    blockNode: { data },
  } = props;
  const containerRef = useRef(null);

  return (
    <div className="px-6">
      <YouTubeVideoList channelId={data.channelID} apiKey={data.apiKey || ""} />
    </div>
  );
};
